<template>
  <div class="bd-content kw_stats">
    <h3 class="page_title_small">Статистика по ключевым словам {{period}}</h3>

    <div class="kw_stats__filters d-flex" v-if="keywordsStats.length">
      <div class="kw_stats__filter kw_stats__filter__adv">
        <multiselect
        :class="{
           active: competitorsFilter,
           blue: true
        }"
        v-model="competitorsFilter"
        deselect-label="✓"
        select-label=""
        selectedLabel="✓"
        :options="competitors"
        :multiple="false"
        :close-on-select="true"
        :clear-on-select="false"
        :preserve-search="true"
        label="title"
        :searchable="false"
        track-by="id"
        :taggable="false"
        openDirection="below"
        :allowEmpty="false"
        @input="selectCompetitorsFilter"
        @select="fetchKeywordsStats()"
        :disabled="false"
        placeholder="Рекламодатель"
      >
      </multiselect>
      </div>
      <div class="kw_stats__filter__percshowup">
        <multiselect
         :value="filterBy"
         :options="filterByOptions"
         :searchable="false"
         :show-labels="false"
         label="title"
         track-by="value"
         placeholder='Сортировать по'
         :allowEmpty="false"
         @input="selectFilterBy"
         :close-on-select="true"
         :disabled="false">
      </multiselect>
      </div>
      <div class="kw_stats__filter">
        <multiselect
         :value="topPersistenceFilterType"
         :options="topPersistenceFilterTypeOptions"
         :searchable="false"
         :show-labels="false"
         label="title"
         track-by="title"
         placeholder='Больше или меньше'
         :close-on-select="true"
         :allowEmpty="false"
         @input="selectTopPersistenceFilterType"
         :disabled="false"
          class="results_in_top_filter_options">
    </multiselect>
      </div>
      <div class="kw_stats__filter">
         <input
            v-model="topPersistenceFilterValueModel"
            placeholder="Значение"
            type="number"
            class="form-control kw_stats__filter__value"
          >
      </div>
      <div class="kw_stats__filter__apply">
        <b-button @click="fetchKeywordsStats()" class="btn-success float-right">
<!--          selectTopPersistenceFilterType(); selectTopPersistenceFilterValue(); selectFilterBy();-->
          Применить
        </b-button>
      </div>
      <download-button :downloadReportType="downloadReportType" :urls="[keywordsDownloadLink]"></download-button>
    </div>
    <results-table :fields="fields" :items="keywordsStats" v-if="keywordsStats.length"/>
    <preloader v-if="loading"/>
  </div>

</template>
<script>
import ResultsTable from "../positions/reports/TableResults";
import EventHubListenerMixin from "../common/mixins/EventHubListener";
import DownloadButton from "../common/DownloadButton";
import Multiselect from "vue-multiselect";
import Preloader from "../common/Preloader";

import {mapActions, mapGetters} from "vuex";

const axios = require("axios").default;

export default {
  components: {
    ResultsTable,
    EventHubListenerMixin,
    Multiselect,
    DownloadButton,
    Preloader
  },

  data(){
    return {
      header: "Ститистика по ключевым словам",
      ourLabels: "There are no active advertisers",
      events: ["updateData"],
      fields: [
        {key: "keyword", label: "Ключевое слово"},
        {key: "meanPosition", label: "Средняя позиция"},
        {key: "sov", label: "SOV"},
        {key: "resultsInTop", label: "Процент показов наверху страницы"},
      ],
      errorMessage: '',
      downloadReportType: 'export-keywords-dynamic'
    }
  },

  computed: {
    ...mapGetters("keywords", [
        "keywordsDownloadLink",
        "keywordsStats",
        "topPersistenceFilterTypeOptions",
        "topPersistenceFilterType",
        "topPersistenceFilterValue",
        "filterBy",
        "filterByOptions",
        "loading",
    ]),
    ...mapGetters(["competitors"]),
    ...mapGetters("filters", ["competitorsFilter", "resultsPeriod"]),
    topPersistenceFilterValueModel: {
      get () {
        return this.topPersistenceFilterValue
      },
      set(value) {
        this.selectTopPersistenceFilterValue(value)
      }
    },
    period(){
      if (this.resultsPeriod){
        return `за ${this.resultsPeriod}`
      }
    }
  },

  async mounted() {
    await this.fetchKeywordsStats()
  },

  methods: {
    ...mapActions("keywords", [
        "fetchKeywordsStats",
        "selectTopPersistenceFilterType",
        "selectTopPersistenceFilterValue",
        "selectFilterBy",
    ]),
    ...mapActions("filters", [
        "selectCompetitorsFilter",
    ]),

    renderHeader(text) {
      return `${text}`;
    },
  },
};
</script>
<style>
</style>
